import { sortBy } from 'lodash';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, deepStringFind, inject, NothingHere, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBuilding } from '@react-icons/all-files/bs/BsBuilding';
import { RouteComponentProps } from 'react-router';
import { Input } from 'reactstrap';
import { ContractsStore } from '../Contracts/ContractsStore';
import { AppStore } from '../Core/AppStore';
import { AccountItem } from './AccountItem';
import { AccountsStore } from './AccountsStore';

export interface IAccountListProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class AccountsList extends React.Component<IAccountListProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.accountsStore.loadAsync();
            await this.contractsStore.loadAllAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <Title>Accounts</Title>

                <SubTopBar>
                    <Input
                        type="text"
                        placeholder="Search Accounts/Contracts..."
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                    />
                </SubTopBar>

                <div className="row">
                    <div className="col-12 px-0">
                        <table className="table table-sm table-striped fixed-header table-borderless">
                            <thead className="thead">
                                <tr>
                                    <th scope="col" className="no-wrap">
                                        Name
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Service Level
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Contract Status
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Term Length
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        Start Date
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        End Date
                                    </th>
                                    <th scope="col" className="no-wrap">
                                        <div className="text-center">Options</div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.accounts?.map(a => (
                                    <AccountItem
                                        key={a.accountNumber}
                                        account={a}
                                        forceOpen={!!this.searchValue}
                                        contracts={this.contractsStore.accountContracts.get(a.accountNumber) || []}
                                        history={this.props.history}
                                    />
                                ))}
                            </tbody>
                        </table>

                        <NothingHere
                            empty={!this.accounts.length}
                            icon={<BsBuilding />}
                            loading={this.loading}
                            label="No Accounts"
                            loadingMessage="Loading Accounts..."
                        />
                    </div>
                </div>
            </div>
        );
    }

    @computed
    private get accounts() {
        let accounts = Array.from(this.accountsStore.accounts, ([k, v]) => v);
        accounts = sortBy(accounts, a => a.accountName);
        if (this.searchValue)
            accounts = accounts.filter(o => {
                return (
                    deepStringFind(o, this.searchValue) ||
                    deepStringFind(this.contractsStore.accountContracts.get(o.accountNumber), this.searchValue)
                );
            });

        return accounts;
    }

    @action
    @bind
    private async onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @observable
    private loading = false;
    @observable
    private searchValue: string = '';
    @inject
    private accountsStore!: AccountsStore;
    @inject
    private contractsStore!: ContractsStore;
    @inject
    private appStore!: AppStore;
}
